// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedWorksCard-cls1_2T5","cls2":"RelatedWorksCard-cls2_M-j RelatedWorksCard-cls1_2T5","altLook":"RelatedWorksCard-altLook_KgJ"};